import APIUser from '@/xhr/xhr-user'

const namespaced = true

const initialState = {
  code_request_id: null
}
export const state = { ...initialState }

const getters = {
  code_request_id: state => state.code_request_id
}

const mutations = {
  setCodeRequestId (state, id) {
    state.code_request_id = id
  },
  clear (state) {
    state.code_request_id = null
  }
}

const actions = {
  // 本人確認依頼（メールアドレス変更）
  sendChangeMail ({commit}, params) {
    return new Promise((resolve, reject) => {
      APIUser.changeMail({
        mail: params.mail
      }).then(_res => {
        commit('setCodeRequestId', _res.data.code_request_id)
        resolve(_res.data)
      }).catch(err => {
        reject(err.response)
      })
    })
  },

  // 本人確認（メールアドレス変更）
  // ※ 更新対象がメールだけなので、本人確認がOKなら更新も一緒に実行される = changeMailアクションなし
  checkChangeMailCode ({commit}, params) {
    return new Promise((resolve, reject) => {
      APIUser.changeMailCode({
        id: params.id,
        authentication_code: params.authentication_code
      }).then((_res) => {
        resolve(_res.data)
      }).catch(function (err) {
        reject(err.response)
      })
    })
  }
}

// モジュールに登録されるオブジェクト
export default {
  namespaced,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/mailChange.js